import { z } from "zod";
import {
  groupedInvoicingActivityOccurrenceSchema,
  invoicingGroupSchema,
} from "./invoicing";

// An invoicing row as the logistics host sends it, with the patient still an
// id. See activities.unenriched.ts for why the two are joined in the client.
export const unenrichedInvoicingActivityOccurrenceSchema =
  groupedInvoicingActivityOccurrenceSchema;

export const unenrichedInvoicingGroupSchema = invoicingGroupSchema
  .omit({ patient: true })
  .extend({ patientId: z.uuid() });

export const unenrichedInvoicingActivityOccurrenceOrGroupSchema = z.union([
  unenrichedInvoicingActivityOccurrenceSchema,
  unenrichedInvoicingGroupSchema,
]);
export type IUnenrichedInvoicingActivityOccurrenceOrGroup = z.infer<
  typeof unenrichedInvoicingActivityOccurrenceOrGroupSchema
>;
